import { Check, X } from "lucide-react";
import { useRef, useState } from "react";

interface TableRow {
  feature: string;
  subItem?: string;
  freeValue?: string | boolean;
  proValue?: string | boolean;
}

const tableData: TableRow[] = [
  {
    feature: "Min. Investment",
    freeValue: "USD 250",
    proValue: "USD 1,000"
  },
  {
    feature: "Verified by METRADE",
    freeValue: false,
    proValue: true
  },
  {
    feature: "Exchanges",
    subItem: "OKX",
    freeValue: false,
    proValue: true
  },
  {
    feature: "",
    subItem: "BYBIT",
    freeValue: true,
    proValue: true
  },
  {
    feature: "",
    subItem: "Bitget",
    freeValue: true,
    proValue: true
  },
  {
    feature: "Strategy Options",
    subItem: "BTC",
    freeValue: true,
    proValue: true
  },
  {
    feature: "",
    subItem: "BTC/ETH",
    freeValue: false,
    proValue: true
  },
  {
    feature: "",
    subItem: "ETH",
    freeValue: false,
    proValue: true
  },
  {
    feature: "",
    subItem: "Future Trading",
    freeValue: false,
    proValue: true
  },
  {
    feature: "",
    subItem: "Spot Trading",
    freeValue: false,
    proValue: true
  },
  {
    feature: "Support",
    freeValue: true,
    proValue: "Premium"
  }
];

const ComparisonTable = () => {
  const [showScrollHint, setShowScrollHint] = useState(true);
  const tableRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (tableRef.current) {
      const isScrolled = tableRef.current.scrollLeft > 0;
      setShowScrollHint(!isScrolled);
    }
  };

  return (
    <div className="relative">
      {showScrollHint && (
        <div className="absolute -right-2 top-1/2 transform -translate-y-1/2 bg-white/90 px-3 py-2 rounded-l-lg text-sm text-[#007BFF] shadow-md animate-pulse md:hidden">
          <span>Swipe →</span>
        </div>
      )}
      
      <div 
        ref={tableRef} 
        onScroll={handleScroll} 
        className="overflow-x-auto -mx-4 sm:mx-0 mb-8 sm:mb-16 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent"
      >
        <div className="min-w-[800px] px-4 sm:px-0">
          <table className="w-full border-collapse rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-[#1B2F47] text-white">
                <th className="py-4 px-6 text-left w-[30%] font-medium">
                  Feature / Category
                </th>
                <th className="py-4 px-6 text-left w-[30%] font-medium">
                </th>
                <th className="py-4 px-6 w-[20%] bg-[#234872]">
                  <div className="flex flex-col items-center">
                    <img 
                      src="/lovable-uploads/27af125a-cfec-4344-80be-6386e5705f9b.png"
                      alt="FREE"
                      className="h-5 mb-1"
                    />
                    <p className="text-xs opacity-80">
                      Basic copy trading
                    </p>
                  </div>
                </th>
                <th className="py-4 px-6 w-[20%] bg-[#1B2F47]">
                  <div className="flex flex-col items-center">
                    <img 
                      src="/lovable-uploads/ed075197-9d8a-481b-8e84-196b53538982.png"
                      alt="PREMIUM"
                      className="h-5 mb-1"
                    />
                    <p className="text-xs opacity-80">
                      METRADE Premium
                    </p>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData.map((row, index) => (
                <tr
                  key={index}
                  className={`
                    border-b border-[#E5E7EB] hover:bg-[#F8FAFC] transition-colors
                    ${index % 2 === 0 ? 'bg-white' : 'bg-[#F1F5F9]'}
                  `}
                >
                  <td className={`py-3 px-6 font-medium text-[#334155] ${!row.feature && 'border-l-4 border-l-transparent'}`}>
                    {row.feature}
                  </td>
                  <td className="py-3 px-6 text-[#4A607B]">
                    {row.subItem && (
                      <div className="flex items-center gap-2">
                        {!row.feature}
                        <span>{row.subItem}</span>
                      </div>
                    )}
                  </td>
                  <td className="py-3 px-6">
                    <div className="flex justify-center">
                      {typeof row.freeValue === 'string' ? (
                        <span className="font-medium text-[#334155]">{row.freeValue}</span>
                      ) : row.freeValue ? (
                        <Check className="text-[#10B981] w-5 h-5" />
                      ) : (
                        <X className="text-[#EF4444] w-5 h-5" />
                      )}
                    </div>
                  </td>
                  <td className="py-3 px-6">
                    <div className="flex justify-center">
                      {typeof row.proValue === 'string' ? (
                        <span className="font-medium text-[#334155]">{row.proValue}</span>
                      ) : row.proValue ? (
                        <Check className="text-[#10B981] w-5 h-5" />
                      ) : (
                        <X className="text-[#EF4444] w-5 h-5" />
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ComparisonTable;
